import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

import money_clock from './imageFiles/money_clock.png';

const MoneyClock = (props: IllustrationProps) => (
  <Box
    w={72}
    {...props}
    minw={72}
    className={`FDBIllustration${
      props?.className ? ` ${props.className}` : ''
    }`}
  >
    <img
      src={money_clock}
      style={{ width: '100%' }}
      alt="Money Clock Illustration"
    />
  </Box>
);
export default MoneyClock;
